import { Component } from '@angular/core';

/**
 * Component to display help section
 * @export
 * @class OrgHelpContactComponent
 */
@Component({
  selector: 'org-help-contact',
  templateUrl: './org-help-contact.component.html',
  styleUrls: ['./org-help-contact.component.scss'],
})
export class OrgHelpContactComponent {}
